export default {
  size: {
    label: 'Predvolená veľkosť papiera',
    tooltip: 'Určuje veľkosť papiera, ktorá je vždy predvolene vybraná.',
  },
  language: {
    label: 'Jazyk',
    tooltip: 'Reporty zobrazujú texty svojich blokov, dátumy a čísla v tomto jazyku. Názvy a ďalšie texty zadané používateľmi zostávajú nezmenené.',
  },
  showTimezone: {
    label: 'Zobraziť časové pásmo',
    tooltip: 'Dátumy a časy v reportoch uvádzajú svoje časové pásmo, napr. SEČ. Vypnite to, ak sú všetky vaše lokality v jednom časovom pásme',
  },
  header: {
    height: {
      tooltip: 'Určuje výšku hlavičky používanú na každej strane reportu.',
    },
    contentLeft: {
      tooltip: 'Určuje ľavý text hlavičky zobrazený na každej strane reportu.',
    },
    contentCenter: {
      tooltip: 'Určuje stredový text hlavičky zobrazený na každej strane reportu.',
    },
    contentRight: {
      tooltip: 'Určuje pravý text hlavičky zobrazený na každej strane reportu.',
    },
  },
  footer: {
    contentLeft: {
      tooltip: 'Určuje ľavý text päty zobrazený na každej strane reportu.',
    },
    contentCenter: {
      tooltip: 'Určuje stredový text päty zobrazený na každej strane reportu.',
    },
    contentRight: {
      tooltip: 'Určuje pravý text päty zobrazený na každej strane reportu.',
    },
  },
};
